module.exports = __webpack_public_path__ + "static/media/icon_menu_sidebar.0a335e0a.png";